export const MOBILE_SIZE = "(max-width: 767px)";
export const TABLET_SIZE = "(min-width: 768px) and (max-width: 1024px)";
export const PC_SIZE = "(min-width: 1025px)";
